import React from "react";

export default function PageHeader({ title, breadcrumb, right }) {
  return (
    <div className="glass-card-sm flex items-center justify-between px-6 py-4 mb-6">
      <div>
        <div className="flex items-center gap-2 text-[12px] mb-1" style={{ color: "var(--slate-500)" }}>
          <span>Opsora</span>
          <span>›</span>
          <span>{breadcrumb}</span>
        </div>
        <h1
          className="font-display"
          style={{ fontSize: "22px", color: "var(--slate-900)", lineHeight: 1.2 }}
          data-testid="page-title"
        >
          {title}
        </h1>
      </div>
      {right && <div className="flex items-center gap-3">{right}</div>}
    </div>
  );
}
